import { EnrolledCareProgram } from 'features/profile/types';
import { CareProgramsAPIResponse } from 'features/resources/types';
import { WellframeApi } from 'store/api';

export const careProgramService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getCarePrograms: builder.query<
      CareProgramsAPIResponse,
      {
        memberUuid: string;
        locale?: string;
      }
    >({
      query: ({ memberUuid, locale }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/care-programs`,
        params: locale ? { locale: locale.split('-')[0] } : undefined,
      }),
    }),
    searchCarePrograms: builder.query<
      CareProgramsAPIResponse,
      {
        memberUuid: string;
        query: string;
        locale?: string;
      }
    >({
      query: ({ memberUuid, query, locale }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/care-programs/search`,
        params: { query, ...(locale ? { locale: locale.split('-')[0] } : {}) },
      }),
    }),
    getEnrolledCarePrograms: builder.query<EnrolledCareProgram[], { programUserId: number }>({
      query: ({ programUserId }) => `/mobileapi/v1/member/care-program/${programUserId}`,
    }),
  }),
});

export const {
  useGetCareProgramsQuery,
  useSearchCareProgramsQuery,
  useGetEnrolledCareProgramsQuery,
} = careProgramService;
